// tslint:disable-next-line:no-any
export const formatUserName = (user: any): string => {
  if (user.last_name && user.first_name) {
    return user.first_name + ' ' + user.last_name;
  } else {
    return user.last_name || user.first_name || '';
  }
};
